import { render, staticRenderFns } from "./AdditionalServicePriceListPage.vue?vue&type=template&id=12847bc2&scoped=true&"
import script from "./AdditionalServicePriceListPage.vue?vue&type=script&lang=js&"
export * from "./AdditionalServicePriceListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12847bc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12847bc2')) {
      api.createRecord('12847bc2', component.options)
    } else {
      api.reload('12847bc2', component.options)
    }
    module.hot.accept("./AdditionalServicePriceListPage.vue?vue&type=template&id=12847bc2&scoped=true&", function () {
      api.rerender('12847bc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/AdditionalServicePriceListPage.vue"
export default component.exports